export const KYC_MAX_UPLOAD_SIZE = 5;

export const KYC_TYPES = {
    ID_AND_PASSPORT: 'IP',
    ID_PASSPORT_LIVENESS: 'IPL',
    SELFIE_WITH_ID_AND_PASSPORT: 'S',
    BANK_BOOK: 'B',
    UTILITY: 'U',
    REAL_TIME: 'R',
    CPF: 'CPF',
};

export const KYC_TYPES_STATUS = {
    APPROVED: 'A',
    REJECTED: 'R',
    PENDING: 'P',
    INITIATE: 'I',
    DOCUMENTREQUESTED: 'DR',
};

export const KYC_TOOL_TIP_CONTENT = {
    IP: 'kyc:tooltipIDPassport',
    IPL: 'kyc:tooltipIDPassportAndLiveness',
    IPL2: 'kyc:tooltipIDPassportAndLiveness2',
    S: 'kyc:tooltipSelfie',
    B: 'kyc:tooltipBankbook',
    U: 'kyc:tooltipUtility',
    R: 'kyc:tooltipRealTime',
    VP: 'kyc:tooltipVerifiedPlus',
    CPF: 'kyc:tooltipCpf',
};

export const KYC_POPUP_INITIATE = {
    COMPLIANCE: 'FROM_COMPLIANCE',
    MEMBER: 'FROM_MEMBER',
};
